import React from "react"
import Billingconfiguration from '../../../custommodules/billingconfiguration'


const BillingconfigurationRules = () => {

    return (
        <div style={{ height: '100%', overflow: 'auto' }}>
            <Billingconfiguration /> 
        </div>
    )
}
export default BillingconfigurationRules